import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Flex } from '@stepstone-genesis/components';
import { BenefitItem } from './BenefitItem.js';
import { useAppSelector } from '../../../../../redux/hooks.js';
import { logoBrandNameSelector } from '../../../../../redux/core/siteConfig/siteConfigSlice.js';
import { useBuildBenefitsLabels } from '../../../../../helpers/useBuildBenefitsLabels.js';
export const Benefits = () => {
    const logoBrandName = useAppSelector(logoBrandNameSelector);
    // number of benefits to display should be read from configs
    const benefits = useBuildBenefitsLabels(logoBrandName);
    return (_jsx(Flex, { flxDirection: 'column', gap: ['spaceXs', 'spaceS', 'spaceS2'], sx: { height: '100%' }, children: benefits.map((benefit) => {
            return _jsx(BenefitItem, { text: benefit }, benefit);
        }) }));
};
//# sourceMappingURL=Benefits.js.map